import * as React from 'react';
import { TableRow } from 'desktop--design-library';
import { currencyFormatter } from 'easit--localization';

export interface ITicketRowProps {
    combination: string,
    potentialPrize: number,
    rate: number,
    stake: number
}

export const TicketRow: React.FC<ITicketRowProps> = props => {
    return (
        <TableRow className={`betdetail-row`} verticalAlign={"center"}>
            <div className={"combination-name text-left px-2"}>
                {props.combination}
            </div>
            <div className={"rate-value"}>
                {props.rate}
            </div>
            <div className={"stake-value"}>
                {currencyFormatter.format(props.stake)}
            </div>
            <div className={"prize-potential"}>
                {currencyFormatter.format(props.potentialPrize)}
            </div>
        </TableRow>
    );
};